import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL + "/assets/";
const publicEndpoint = process.env.VUE_APP_RESOURCE_URL + '/assets/';

const getAssetPriceList = () => {
  return http.get(publicEndpoint + "price/list");
};

const getAssetList = () => {
  return http.get(publicEndpoint + "list");
};

const getAsset = (symbol) => {
  return http.get(publicEndpoint + "list/" + symbol);
};

const getAssetPrice = (asset) => {
  return http.get(publicEndpoint + "price/" + asset + "/USDT");
};

const getPairPrice = (fromAsset, toAsset) => {
  return http.get(publicEndpoint + "price/" + fromAsset + "/" + toAsset);
};

const getAssetInfo = (symbol) => {
  return http.get(publicEndpoint + symbol);
};

const getCoins = () => {

  return http.get(endpoint);
};

const asyncAssets = () => {
  return http.post('ControllerPanel/SyncAssets', {}, {
    baseURL: process.env.VUE_APP_BASE_URL
  });
};

export {
  getAssetPriceList,
  getAssetList,
  getAsset,
  getAssetPrice,
  getAssetInfo,
  getPairPrice,
  getCoins,
  asyncAssets,
};
